var aspectRatio;
var ratio_scale = 0;
var resize_methods = [];
var maxAspectRatio = 3;
var minAspectRatio = 1 / maxAspectRatio;
var resize_methods = [];
var formats = [16 / 9, 9 / 16, 4 / 3];
var LANDSCAPE = 0;
var PORTRAIT = 1;
var DESKTOP = 2;
var currentFormat;

//  performace / resolution
var canvas_scale = 1;
if (is.mobile()) {
  canvas_scale = 1.25;
}

function resize() {
  if (APP == undefined) return;

  var width_inner = window.innerWidth / canvas_scale;
  var height_inner = window.innerHeight / canvas_scale;
  if (width_inner / height_inner > maxAspectRatio) {
    width_inner = height_inner * maxAspectRatio;
  }
  if (width_inner / height_inner < minAspectRatio) {
    height_inner = width_inner / minAspectRatio;
  }

  APP.renderer.resize(width_inner, height_inner);

  setRatioScale();

  aspectRatio = APP.screen.width / APP.screen.height;
  var minDiff = 99999;
  var minIndex;
  for (var i = 0; i < formats.length; i++) {
    var diff = Math.abs(formats[i] - aspectRatio);
    if (diff < minDiff) {
      minIndex = i;
      minDiff = diff;
    }
  }
  currentFormat = minIndex;

  for (var i = 0; i < resize_methods.length; i++) {
    resize_methods[i]();
  }

  //    var scaleX = window.innerWidth / APP.screen.width;
  //    var scaleY = window.innerHeight / APP.screen.height;
  //
  //    var scaleToFit = Math.min(scaleX, scaleY);
  //    var scaleToCover = Math.max(scaleX, scaleY);

  APP.view.style.transformOrigin = "0 0";
  APP.view.style.transform = "scale(" + canvas_scale + ")";
}

function setRatioScale() {
  if (window.innerHeight < window.innerWidth) {
    ratio_scale = window.innerHeight / 1080 / canvas_scale;
  } else {
    ratio_scale = window.innerWidth / 1080 / canvas_scale;
  }
}

$(window).on("resize", function () {
  if (getOS() == "iOS") {
    setTimeout(function () {
      resize();
    }, 150);
  } else {
    resize();
  }
});
